import { render, staticRenderFns } from "./login-popup.vue?vue&type=template&id=464dc2f3&"
import script from "./login-popup.vue?vue&type=script&lang=ts&"
export * from "./login-popup.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\wamp\\www\\Pentacom\\baumit.com\\vue-project\\calculator-common\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('464dc2f3')) {
      api.createRecord('464dc2f3', component.options)
    } else {
      api.reload('464dc2f3', component.options)
    }
    module.hot.accept("./login-popup.vue?vue&type=template&id=464dc2f3&", function () {
      api.rerender('464dc2f3', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/getting-discount/login-popup.vue"
export default component.exports